<template>  
  <div v-if="loading" class="loading">Loading...</div>
  <div class="relative bg-cover bg-center bg-[#BADEEF] h-screen w-screen">
      <div class="h-full flex flex-col">
          
          <div class='h-2/3 flex justify-center relative xl:pt-20 lg:pt-8 md:pt-8 sm:pt-10  p-4'>
            <div class="flex flex-col w-2/3 gap-2">
              <div class="flex justify-center gap-x-2 border-[#4D8E63] xl:border-8 lg:border-[3px] md:border-[3px] sm:border-[3px] right-6 xl:p-4 lg:p-2 md:p-2 sm:p-1 rounded-[5rem]">
                <p class="xl:text-4xl lg:text-4xl md:text-3xl sm:text-2xl text-center ">ภาวะสมองเสื่อม (Dementia)</p>
                <div class="flex items-center justify-center p-2">
                  <img class="w-14 h-14" src="../assets/materials/search-green.png" alt="search">
                </div>
              </div>
              <div class="xl:p-6 lg:p-2 md:p-2 sm:p-1">
                <p class="xl:text-4xl lg:text-4xl md:text-1xl sm:text-lg text-center">เป็นภาวะที่สมองเริ่มถดถอยการทำงานด้านใดด้านหนึ่งลงไป เช่น ด้านความจำ ด้านภาษา ด้านการประมวลผล และด้านสมาธิ โดยจะเริ่มสูญเสียเซลล์สมองจากส่วนหนึ่งแล้วค่อยลุกลามไปยังสมองอีกส่วนหนึ่งอย่างช้า ๆ</p>
              </div>
            </div>
            <div class="xl:w-2/3 lg:w-2/3 md:w-2/5 sm:w-1/3">
              <img src="../assets/materials/old-girl.png" alt="old-girl">
            </div>
          </div>
          
          <div class="h-1/3 w-full px-20">
            <router-link :to="`/videoL`">                
              <button class='hover:ring-8 hover:ring-[#ade6c1] w-full rounded-3xl flex items-center justify-center bg-[#4D8D63]'>
                <img class="xl:w-64 lg:w-48 md:w-36 sm:w-36" src="../assets/materials/brain-pink.png" alt="brain-pink">
                <p class="text-white xl:text-5xl lg:text-4xl md:text-1xl sm:text-xl">
                  ถ้าไม่อยากเป็นแบบนี้ <br>
                  เรามาเริ่มเล่นเกม CRA BRAINY กันเถอะ 
                </p>
              </button>
            </router-link>
          </div>
      </div>        
  </div>         
</template>

<script>
import soundDementia from '.././js/sound-dementia';

export default {
  name: "Dementia",    
  created () {
    soundDementia()
  }
};
</script>